import LAHeroSection from "./components/HeroSection";
import LACitiesDirectory from "./components/CitiesDirectory";
import LAStateResources from "./components/StateResources";
import LAFAQSection, { faqs } from "./components/FAQSection";
import LAFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const louisianaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function LouisianaPage() {
  return (
    <>
      <CitySEOHead
        city="Louisiana"
        state="Louisiana"
        stateAbbr="LA"
        route="/states/louisiana"
        title="Louisiana Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Louisiana — New Orleans, Baton Rouge, Shreveport, Lafayette, Lake Charles. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Louisiana, United States"
        geoPosition="30.9843;-91.9623"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={louisianaServices}
      />
      <div className="font-sans">
        <LAHeroSection />
        <LACitiesDirectory />
        <LAStateResources />
        <LAFAQSection />
        <SEOCrossLinks state="LA" />
        <LAFinalCTA />
      </div>
    </>
  );
}